$(document).ready(function () {
  // Heyzine flipbook modal (product pages only — metafield-driven)
  if ($('body').hasClass('product')) {
    var modal = document.getElementById('flipbookModal');
    var triggers = document.querySelectorAll('.open-flipbook');
    var closeBtn = document.getElementById('closeFlipbook');

    triggers.forEach(function (trigger) {
      trigger.addEventListener('click', function (e) {
        e.preventDefault();
        if (!modal) return;

        var iframe = modal.querySelector('iframe[data-flipbook-src]');
        if (iframe && !iframe.dataset.flipbookLoaded) {
          iframe.src = iframe.getAttribute('data-flipbook-src');
          iframe.dataset.flipbookLoaded = 'true';
        }

        modal.style.display = 'block';
      });
    });

    if (closeBtn) {
      closeBtn.addEventListener('click', function () {
        if (modal) modal.style.display = 'none';
      });
    }

    window.addEventListener('click', function (event) {
      if (modal && event.target === modal) modal.style.display = 'none';
    });
  }

  // PageFly homepage: product image/title → product page (media had clickAction disabled)
  if ($('body').hasClass('index')) {
    $(document).on('click', '[data-pf-type="ProductBox"]', function (e) {
      if ($(e.target).closest('[data-pf-type="ProductATC2"], button[name="add"], .pf-product-form').length) {
        return;
      }
      if (!$(e.target).closest('[data-pf-type="MediaMain"], [data-pf-type="ProductMedia2"], [data-pf-type="ProductTitle"]').length) {
        return;
      }
      var url =
        $(this).find('[data-pf-type="MediaMain"]').attr('data-href') ||
        $(this).find('[data-pf-type="ProductTitle"]').attr('data-href') ||
        $(this).find('[data-pf-type="ProductTitle"] a').attr('href');
      if (url) {
        window.location.href = url;
      }
    });
  }

  //remove quantity and add to cart from free gift card product page
  removeElement(".product.yopandtom-gdpr .product-8059483652350 .product-quantity-box");
  removeElement(".product.yopandtom-gdpr .product-8059483652350 .purchase-details__buttons");

  //remove plus/minus buttons from free gift card in cart
  removeElement(".item-id-44040971485438 .product-minus");
  removeElement(".item-id-44040971485438 .product-plus");

  //set max from free gift card in cart
  setMax(".item-id-44040971485438 .product-quantity-box .quantity", 1);
  
  //remove links from free gift card in cart
  removeLink(".item-id-44040971485438 .cart_page_image");
  removeLink(".item-id-44040971485438 .cart__item--title a");
});

function disableField(val) {
    $(val).prop('disabled', true);
}
function removeElement(val) {
    $(val).detach();
}
function removeLink(val) {
    $(val).removeAttr("href");
}
function setMax(field,val) {
    $(field).attr('max', val);
}

//Only run on cart page
if( window.location.pathname == '/cart') {
  
  //Catch all the AJAX Request to Cart.JS and Cart/Change.JS
  $( document ).ajaxComplete(function( event, xhr, settings ) {
    if ( settings.url === "/cart.js" ) {
      //console.log( "Cart.JS = Triggered ajaxComplete handler. The result is " + xhr.responseText + ' TOTAL PRICE = ' + parseFloat( xhr.responseText.split(",")[4].split(":")[1] )/100 );
      total_price = parseFloat( xhr.responseText.split(",")[4].split(":")[1] )/100;
  
      //console.log(total_price);

      
      if(total_price < 50) {
        //console.log("Remove freebie");
        if( $('.item-id-44040971485438').length ) {
          //console.log('freebie exists');
          //$(".item-id-44040971485438 .product-quantity-box .quantity").val(0).trigger("change");
          window.location.replace('/cart/change?line=1&quantity=0');
        }
      }
    }
  
  });

}

//Redirect from free giftcard
if( window.location.pathname == '/products/giftcard-5') {
   window.location.replace('/products/giftcards');
}